type RedirectProps = {
  to: string;
  method?: string;
};

const Redirect = ({ to, method = "assign" }: RedirectProps) => {
  const url = to.startsWith("http") ? to : window.location.origin + to;
  window.location[method](url);
  return null;
};

export default Redirect;
